<template>
  <div class="editAddr">
    <div class="inputBox">
      <span class="t1">姓名</span>
      <input type="text" placeholder="请输入姓名" v-model="addr.receive_name" maxlength="16" />
    </div>
    <div class="inputBox">
      <span class="t1">手机号</span>
      <input type="text" placeholder="请输入手机号码" v-model="addr.receive_tel"  maxlength="11"/>
    </div>
    <div class="inputBox" @click="show=true">
      <span class="t1">所在地区</span>
      <input type="text" :placeholder="addr.address_title | pcaFilter" />
      <img src="../../assets/my/next2.png"  />
    </div>
    <div class="textBox">
      <span class="t1">详细地址</span>
      <textarea cols="30" rows="3" placeholder="请输入详细地址" v-model="addr.receive_address" maxlength="40"></textarea>
    </div>

    <div class="bottom">
      <div class="is_default">
        <img :src="is_defaultImg" @click="addr.is_default = !addr.is_default" />
        <span>设为默认</span>
      </div>
      <input class="input1" type="button" value="确认修改" @click="edit" />
      <input class="input2" type="button" value="删除地址"  @click="del"/>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-area :area-list="areaList" @confirm="confirm" @cancel="cancel" />
    </van-popup>
  </div>
</template>


<style lang="less" scoped>
.editAddr {
  .inputBox {
    display: flex;
    align-items: center;
    background-color: #fff;
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    padding: 0 24px;
    border-bottom: 1px solid #eee;
    .t1 {
      font-size: 32px;
      color: #333;
      width: 200px;
      margin-right: 10px;
    }
    input {
      flex: 1;
      font-size: 32px;
      color: #333;
      border: none;
    }
    img {
      width: 20px;
    }
  }
  .textBox {
    display: flex;
    align-items: flex-start;
    background-color: #fff;
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 30px 24px;
    border-bottom: 1px solid #eee;

    .t1 {
      font-size: 32px;
      color: #333;
      width: 200px;
      margin-right: 10px;
    }
    textarea {
      flex: 1;
      overflow: hidden;
      font-size: 32px;
      color: #333;
      border: none;
      box-sizing: border-box;
      padding: 5px;
    }
  }
  .bottom {
    margin-top: 20px;
    width: 100%;
    padding: 20px 24px;
    box-sizing: border-box;
    background-color: #fff;
    .is_default {
      font-size: 28px;
      color: #999;
      img {
        width: 49px;
        height: 49px;
        margin-right: 15px;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
      }
    }
    input {
      width: 702px;
      height: 94px;
      margin-top: 20px;
      display: block;
      box-sizing: border-box;
      border-radius: 10px;
      font-size: 32px;
      text-align: center;
      line-height: 94px;
      border: none;
      -webkit-appearance:none;
    }

    .input1 {
      margin: 100px 0 20px;
      color: #fff;
      background-color: #e42129;
      -webkit-appearance:none;
    }
    .input2 {
      color: #e42129;
      background-color: #fff;
      border: 1px solid #e42129;
    }
  }
}
</style>

<script>
import AreaList from '../../lib/area'
export default {
  data () {
    return {
      is_default: true,
      areaList: AreaList,
      show: false,
      addr:{}
    }
  },
  created () {
    this.addr = this.$route.query

    console.log(this.addr)
  },
  computed: {
    is_defaultImg () {
      return this.addr.is_default
        ? require('../../assets/car/is_sel.png')
        : require('../../assets/car/no_sel.png')
    }
  },
  methods: {
    edit(){
      let addr = this.addr
      let reg = /\S/
      let phoneReg =/^[1][3,4,5,6,7,8,9][0-9]{9}$/ 
      if(!reg.test(addr.receive_name)) return this.$toast('姓名不能为空')

      if(!phoneReg.test(addr.receive_tel)) return this.$toast('请输入正确的手机号码')

      if(!reg.test(addr.receive_address)) return this.$toast('请输入详细地址')

      addr.is_default = addr.is_default? '1':'0'
      this.$http({
        url:'editReceive',
        data:addr
      }).then(res=>{
        this.$toast('地址修改成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500);
      })
    },
    del(){
      let id = this.addr.id
      this.$http({
        url:'delReceive',
        data:{
          id
        }
      }).then(res=>{
        this.$toast('删除成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500);
      })
    },
    cancel () {
      this.show = false
    },
    confirm (e) {
      this.addr.address_title = e.map(item => item.name).join('-')
      this.show = false
    }
  }
}
</script>
